/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExpenseSummary } from './';
import {
    ExpenseSummaryFromJSON,
    ExpenseSummaryFromJSONTyped,
    ExpenseSummaryToJSON,
} from './';
import type { PunchoutDetails } from './';
import {
    PunchoutDetailsFromJSON,
    PunchoutDetailsFromJSONTyped,
    PunchoutDetailsToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpenseBatchSummaryResource
 */
export interface ExpenseBatchSummaryResource {
    /**
     * could be null if quote not yet generated
     * @type {string}
     * @memberof ExpenseBatchSummaryResource
     */
    batchQuoteId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExpenseBatchSummaryResource
     */
    createdDate: Date;
    /**
     * Number of batch for this project
     * @type {number}
     * @memberof ExpenseBatchSummaryResource
     */
    batchCounterInProject: number;
    /**
     * Number of Expense in this batch
     * @type {number}
     * @memberof ExpenseBatchSummaryResource
     */
    nbExpenseInBatch: number;
    /**
     * could be null if quote not yet generated
     * @type {string}
     * @memberof ExpenseBatchSummaryResource
     */
    quotePdfUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExpenseBatchSummaryResource
     */
    clientPurchaseOrderRequired: boolean;
    /**
     * 
     * @type {ExpenseSummary}
     * @memberof ExpenseBatchSummaryResource
     */
    summary: ExpenseSummary;
    /**
     * 
     * @type {PunchoutDetails}
     * @memberof ExpenseBatchSummaryResource
     */
    punchoutDetails?: PunchoutDetails;
}

/**
 * Check if a given object implements the ExpenseBatchSummaryResource interface.
 */
export function instanceOfExpenseBatchSummaryResource(value: object): value is ExpenseBatchSummaryResource {
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('batchCounterInProject' in value) || value['batchCounterInProject'] === undefined) return false;
    if (!('nbExpenseInBatch' in value) || value['nbExpenseInBatch'] === undefined) return false;
    if (!('clientPurchaseOrderRequired' in value) || value['clientPurchaseOrderRequired'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function ExpenseBatchSummaryResourceFromJSON(json: any): ExpenseBatchSummaryResource {
    return ExpenseBatchSummaryResourceFromJSONTyped(json, false);
}

export function ExpenseBatchSummaryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseBatchSummaryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'batchQuoteId': json['batchQuoteId'] == null ? undefined : json['batchQuoteId'],
        'createdDate': (new Date(json['createdDate'])),
        'batchCounterInProject': json['batchCounterInProject'],
        'nbExpenseInBatch': json['nbExpenseInBatch'],
        'quotePdfUrl': json['quotePdfUrl'] == null ? undefined : json['quotePdfUrl'],
        'clientPurchaseOrderRequired': json['clientPurchaseOrderRequired'],
        'summary': ExpenseSummaryFromJSON(json['summary']),
        'punchoutDetails': json['punchoutDetails'] == null ? undefined : PunchoutDetailsFromJSON(json['punchoutDetails']),
    };
}

export function ExpenseBatchSummaryResourceToJSON(value?: ExpenseBatchSummaryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'batchQuoteId': value['batchQuoteId'],
        'createdDate': ((value['createdDate']).toISOString()),
        'batchCounterInProject': value['batchCounterInProject'],
        'nbExpenseInBatch': value['nbExpenseInBatch'],
        'quotePdfUrl': value['quotePdfUrl'],
        'clientPurchaseOrderRequired': value['clientPurchaseOrderRequired'],
        'summary': ExpenseSummaryToJSON(value['summary']),
        'punchoutDetails': PunchoutDetailsToJSON(value['punchoutDetails']),
    };
}

